import { Box, CircularProgress, Typography } from "@mui/material";

const FullPageLoader = ({ text = "Loading..." }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#00000099",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "primary.main",
          mb: 2,
          animationDuration: "900ms",
        }}
      />
      <Typography variant="body1" color="primary.white">
        {text}
      </Typography>
    </Box>
  );
};

export default FullPageLoader;
